export const OPEN = "DRAWER:TRANSCRIPTS:OPEN";
export const CLOSE = "DRAWER:TRANSCRIPTS:CLOSE";
export const SET_CONTENT = "DRAWER:TRANSCRIPTS:CONTENT:SET";
export const RENDERED_CONTENT = "DRAWER:TRANSCRIPTS:CONTENT:RENDERED";